import { jsx as _jsx } from "react/jsx-runtime";
import { invisibleBase } from '../../../r3f/invisibleBase';
import { CanvasItem2D } from '../../../r3f/components/CanvasItem2D';
import { YSortDispatcher } from '../../../r3f/YSortDispatcher.js';
export function Node2D({ node, children }) {
    const props = node.properties;
    // A Node2D is the CanvasItem ritual with nothing of its own to draw: transform, z (with a y-sort
    // rank from its parent), visibility, modulate and material context. Going through CanvasItem2D
    // keeps a Node2D container in step with whatever the ritual gains.
    return (_jsx(CanvasItem2D, { node: node, props: props, children: props.y_sort_enabled ? _jsx(YSortDispatcher, { node: node, children: children }) : children }));
}
invisibleBase(Node2D);
//# sourceMappingURL=Component.js.map